import { useEffect } from "react";
import "./service.css";
const ServicesPrograms = () => {
  useEffect(() => {
    const cards = document.querySelectorAll(".service-card");

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("show");
          }
        });
      },
      { threshold: 0.2 }
    );

    cards.forEach((card) => observer.observe(card));
    return () => observer.disconnect();
  }, []);

  return (
    <section className="services-section" id="services">
      <div className="services-container">
        {/* TITLE */}
        <div className="section-title">
          <h2 style={{ color: "#c72800ff" }}>Our Services & Programs</h2>
          <p>Comprehensive support for advocate professional growth</p>
        </div>

        {/* GRID */}
        <div className="services-grid">
          <div className="service-card">
            <h3 style={{ color: "#c72800ff" }}>📚 Professional Development</h3>
            <p>
              Specialized training programs, workshops, and certification
              courses designed to enhance advocacy skills and legal expertise.
            </p>
          </div>

          <div className="service-card">
            <h3 style={{ color: "#c72800ff" }}>🎯 Mentorship Program</h3>
            <p>
              One-on-one guidance from experienced advocates to support career
              development and practice building.
            </p>
          </div>

          <div className="service-card">
            <h3 style={{ color: "#c72800ff" }}>🌐 Networking Events</h3>
            <p>
              Regular conferences, seminars, and networking sessions for
              advocates to connect and collaborate.
            </p>
          </div>

          <div className="service-card">
            <h3 style={{ color: "#c72800ff" }}>📖 Knowledge Hub</h3>
            <p>
              Access to legal research, case studies, and latest jurisprudence
              from leading Indian courts.
            </p>
          </div>

          <div className="service-card">
            <h3 style={{ color: "#c72800ff" }}>💼 Practice Support</h3>
            <p>
              Resources and guidance for building and managing a successful
              advocacy practice.
            </p>
          </div>

          <div className="service-card">
            <h3 style={{ color: "#c72800ff" }}>⚖️ Ethics & Compliance</h3>
            <p>
              Training on professional ethics, Bar Council guidelines, and
              compliance standards.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServicesPrograms;
